function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Loader from "./../Loader/Loader";
import Select from "react-select";
import { HiDownload } from "react-icons/hi";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import "./WorkLoadAnalysisReport.css";
import { GET_USER_LISTING_QUERY } from "./../MonthlyInOut/query";
import { WORK_LOAD_ANALYSIS_REPORT_QUERY, WORK_LOAD_ANALYSIS_REPORT_EXPORT_QUERY, WORK_LOAD_ANALYSIS_REPORT_CHART_QUERY } from "./query";
import { useQuery, useLazyQuery } from "@apollo/client";
import Chart from "react-google-charts";
import { useTable } from "react-table";
import { TimeFilter } from "./../ProjectReport/DateFilter";
import { arrayToStringOutput, stringToArrayOutput } from "./../SideMenu/Header";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Popover from "react-bootstrap/Popover";
import "./WorkLoadAnalysisReport.css";
import Excel from "exceljs/dist/es5/exceljs.browser";
import { saveAs } from "file-saver";
import Col from "react-bootstrap/Col";
var LIMIT = 15;
var WorkLoadAnalysisReport = function WorkLoadAnalysisReport(props) {
  var _userListData$getUser, _workLoadChartAnalysi, _workLoadAnalysisData, _workLoadAnalysisData2;
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    organisationSettings = _React$useContext.organisationSettings,
    role = _React$useContext.role,
    organisationBilling = _React$useContext.organisationBilling,
    from = _React$useContext.from,
    sD = _React$useContext.startDate,
    eD = _React$useContext.endDate,
    organisationStatus = _React$useContext.organisationStatus;
  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  React.useEffect(function () {
    if (from == "web" && role == "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  React.useEffect(function () {
    if (((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") && role != "Member" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var _React$useState = React.useState({
      label: "All Members",
      value: null
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userParameterCheck = _React$useState2[0],
    setUserParameterCheck = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    workLoadUserDataFetch = _React$useState4[0],
    setWorkLoadUserDataFetch = _React$useState4[1];
  var last7DaysDate = stringToArrayOutput("Last 7 Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  var _React$useState5 = React.useState({
      startDate: last7DaysDate[0],
      endDate: last7DaysDate[1]
    }),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    dates = _React$useState6[0],
    setDate = _React$useState6[1];
  var dateMoment = moment(startDate);
  var startDate = dates.startDate,
    endDate = dates.endDate;
  var _React$useState7 = React.useState(arrayToStringOutput([startDate, endDate], organisationSettings.organisationTimezone)),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    filterData = _React$useState8[0],
    setFilterData = _React$useState8[1];
  var userList = [{
    label: "All Members",
    value: null
  }];
  var _useQuery = useQuery(GET_USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: teamId,
        userRole: role
      },
      skip: !organisationId
    }),
    userListLoading = _useQuery.loading,
    userListData = _useQuery.data,
    userListError = _useQuery.error;
  var _useQuery2 = useQuery(WORK_LOAD_ANALYSIS_REPORT_CHART_QUERY, {
      variables: {
        startTime: Number(moment(startDate).format("x")),
        endTime: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value ? userParameterCheck.value : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: role
      },
      skip: !organisationId || !teamId
    }),
    workLoadChartAnalysisLoading = _useQuery2.loading,
    workLoadChartAnalysisData = _useQuery2.data,
    workLoadChartAnalysisError = _useQuery2.error,
    refetch = _useQuery2.refetch;
  var _useQuery3 = useQuery(WORK_LOAD_ANALYSIS_REPORT_QUERY, {
      variables: {
        startTime: Number(moment(startDate).format("x")),
        endTime: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
        organisationId: organisationId,
        teamId: teamId,
        userId: userParameterCheck.value ? userParameterCheck.value : null,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userRole: role,
        limit: 15,
        offset: 0
      },
      skip: !organisationId || !teamId
    }),
    workLoadAnalysisLoading = _useQuery3.loading,
    workLoadAnalysisData = _useQuery3.data,
    workLoadAnalysisError = _useQuery3.error,
    workLoadAnalysisFetchMore = _useQuery3.fetchMore;
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
    setWorkLoadUserDataFetch(true);
  }, [props.location.key]);
  var _useLazyQuery = useLazyQuery(WORK_LOAD_ANALYSIS_REPORT_EXPORT_QUERY),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getExport = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    exportLoading = _useLazyQuery2$.loading,
    exportData = _useLazyQuery2$.data;
  React.useEffect(function () {
    if (userParameterCheck === null) {
      setUserParameterCheck({
        label: "All Members",
        value: null
      });
    }
  }, [userListData]);
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getUser = userListData.getUserListing) === null || _userListData$getUser === void 0 ? void 0 : _userListData$getUser.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  var onFilterChange = function onFilterChange(dates) {
    setDate(dates);
  };
  var hideOverlay = function hideOverlay() {
    var _document, _document$body, _document$body$click;
    (_document = document) === null || _document === void 0 ? void 0 : (_document$body = _document.body) === null || _document$body === void 0 ? void 0 : (_document$body$click = _document$body.click) === null || _document$body$click === void 0 ? void 0 : _document$body$click.call(_document$body);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-root"
  }, organisationBilling.planName != "free" ? /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-root-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-filter-root"
  }, /*#__PURE__*/React.createElement(HeaderFilter, {
    userParameterCheck: userParameterCheck,
    setUserParameterCheck: setUserParameterCheck,
    userList: userList,
    onFilterChange: onFilterChange,
    startDate: startDate,
    endDate: endDate,
    filterData: filterData,
    hideOverlay: hideOverlay,
    getExport: getExport,
    exportLoading: exportLoading,
    exportData: exportData,
    organisationBilling: organisationBilling,
    organisationId: organisationId,
    dateMoment: dateMoment,
    organisationSettings: organisationSettings,
    role: role,
    teamId: teamId
  })), /*#__PURE__*/React.createElement(ReportChart, {
    workLoadAnalysisChartDetails: workLoadChartAnalysisData === null || workLoadChartAnalysisData === void 0 ? void 0 : (_workLoadChartAnalysi = workLoadChartAnalysisData.workLoadAnalysisReportChart) === null || _workLoadChartAnalysi === void 0 ? void 0 : _workLoadChartAnalysi.workLoadAnalysisChartDetails,
    workLoadChartAnalysisData: workLoadChartAnalysisData,
    workLoadChartAnalysisLoading: workLoadChartAnalysisLoading,
    workLoadChartAnalysisError: workLoadChartAnalysisError,
    organisationSettings: organisationSettings
  }), workLoadAnalysisLoading ? /*#__PURE__*/React.createElement(Loader, null) : workLoadAnalysisError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(ReportTableData, {
    workLoadAnalysisLoading: workLoadAnalysisLoading,
    workLoadAnalysisError: workLoadAnalysisError,
    userWorkLoadData: workLoadAnalysisData === null || workLoadAnalysisData === void 0 ? void 0 : (_workLoadAnalysisData = workLoadAnalysisData.workLoadAnalysisReport) === null || _workLoadAnalysisData === void 0 ? void 0 : _workLoadAnalysisData.userWorkLoadData,
    headerData: workLoadAnalysisData === null || workLoadAnalysisData === void 0 ? void 0 : (_workLoadAnalysisData2 = workLoadAnalysisData.workLoadAnalysisReport) === null || _workLoadAnalysisData2 === void 0 ? void 0 : _workLoadAnalysisData2.headerData,
    workLoadAnalysisData: workLoadAnalysisData,
    workLoadAnalysisFetchMore: workLoadAnalysisFetchMore,
    userParameterCheck: userParameterCheck,
    setWorkLoadUserDataFetch: setWorkLoadUserDataFetch
  })) : /*#__PURE__*/React.createElement(PlanUpgradeMessage, {
    displayName: user.displayName,
    history: props === null || props === void 0 ? void 0 : props.history
  }));
};
export var PlanUpgradeMessage = function PlanUpgradeMessage(props) {
  var displayName = props.displayName,
    history = props.history;
  return /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-header-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "PlanUpdateMsg-text"
  }, "Dear ", displayName, ", Please upgrade your plan to use this page."), /*#__PURE__*/React.createElement("div", {
    className: "PlanUpdateMsg-button-div"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "PlanUpdateMsg-button",
    onClick: function onClick() {
      history.push("/billing");
    }
  }, "Visit Billing Page"))));
};
var HeaderFilter = function HeaderFilter(props) {
  var userParameterCheck = props.userParameterCheck,
    setUserParameterCheck = props.setUserParameterCheck,
    userList = props.userList,
    onFilterChange = props.onFilterChange,
    startDate = props.startDate,
    endDate = props.endDate,
    filterData = props.filterData,
    hideOverlay = props.hideOverlay,
    organisationBilling = props.organisationBilling,
    organisationId = props.organisationId,
    dateMoment = props.dateMoment,
    organisationSettings = props.organisationSettings,
    role = props.role,
    teamId = props.teamId,
    exportLoading = props.exportLoading,
    exportData = props.exportData,
    getExport = props.getExport;
  var getExportData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getExport({
              variables: {
                organisationId: organisationId,
                teamId: teamId,
                userId: userParameterCheck.value,
                startTime: Number(moment(startDate).format("x")),
                endTime: Number(moment(endDate !== null && endDate !== void 0 ? endDate : startDate).format("x")),
                timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
                userRole: role
              }
            });
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getExportData() {
      return _ref.apply(this, arguments);
    };
  }();
  var csvData = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _exportData$workLoadA, _dataValues$;
    var dataArray, dataValues, wb, ws, col, buf, fileName;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          dataArray = [];
          dataValues = exportData === null || exportData === void 0 ? void 0 : (_exportData$workLoadA = exportData.workLoadAnalysisReportExport) === null || _exportData$workLoadA === void 0 ? void 0 : _exportData$workLoadA.userWorkLoadData;
          if (dataValues) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", []);
        case 4:
          wb = new Excel.Workbook();
          ws = wb.addWorksheet();
          col = [{
            header: "Employee",
            key: "employee",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Over Worked(days)",
            key: "overWorked",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Healthy(days)",
            key: "healthy",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }, {
            header: "Less Utilised(days)",
            key: "lessUtilised",
            width: 20,
            style: {
              alignment: {
                vertical: "middle",
                horizontal: "left"
              }
            }
          }];
          (_dataValues$ = dataValues[0]) === null || _dataValues$ === void 0 ? void 0 : _dataValues$.workLoadData.map(function (dTemp) {
            var date = dTemp.date;
            col.push({
              header: date,
              key: date,
              style: {
                alignment: {
                  vertical: "middle",
                  horizontal: "left"
                }
              }
            });
          });
          ws.columns = col;
          dataValues.map(function (userData, index) {
            var user = userData.user,
              workLoadData = userData.workLoadData,
              overWorkedTotalCount = userData.overWorkedTotalCount,
              healthyTotalCount = userData.healthyTotalCount,
              lessUtilisedTotalCount = userData.lessUtilisedTotalCount;
            var workLoadTableDayData = {};
            workLoadData.map(function (dTemp) {
              var date = dTemp.date,
                healthy = dTemp.healthy,
                healthyUserTotal = dTemp.healthyUserTotal,
                lessUtilised = dTemp.lessUtilised,
                lessUtilisedTotal = dTemp.lessUtilisedTotal,
                overWorked = dTemp.overWorked,
                overWorkedUserTotal = dTemp.overWorkedUserTotal;
              var userStatus = null;
              var userWorkedTime = null;
              if (overWorkedUserTotal != 0) {
                userStatus = "overWorked";
                userWorkedTime = overWorked;
              } else if (lessUtilisedTotal != 0) {
                userStatus = "lessUtilised";
                userWorkedTime = lessUtilised;
              } else if (healthyUserTotal != 0) {
                userStatus = "healthy";
                userWorkedTime = healthy;
              }
              workLoadTableDayData = _objectSpread(_objectSpread({}, workLoadTableDayData), {}, _defineProperty({}, date, userWorkedTime));
            });
            ws.addRow(_objectSpread(_objectSpread({
              employee: user.displayName
            }, workLoadTableDayData), {}, {
              overWorked: overWorkedTotalCount,
              healthy: healthyTotalCount,
              lessUtilised: lessUtilisedTotalCount
            }));
          });
          ws.getRow(1).font = {
            bold: true
          };
          _context2.next = 13;
          return wb.xlsx.writeBuffer();
        case 13:
          buf = _context2.sent;
          fileName = "workfolio-workload-analysis-report-".concat(moment(Number(startDate)).format("DD-MMM"), " - ").concat(moment(Number(endDate)).format("DD-MMM"), ".xlsx");
          saveAs(new Blob([buf]), fileName);
        case 16:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [exportData]);
  React.useEffect(function () {
    csvData();
  }, [exportData]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-filter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: userParameterCheck,
    onChange: function onChange(e) {
      return setUserParameterCheck(e);
    },
    options: userList,
    className: "work-load-analysis-report-filter-user-select",
    classNamePrefix: "Filter By User"
  })), /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-date-picker"
  }, /*#__PURE__*/React.createElement("div", {
    className: "report-details-date-picker"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: "click",
    rootClose: true,
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Popover, {
      className: "page-content-wrapper-menu-filter-overlay-trigger"
    }, /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(TimeFilter, {
      onFilterChange: onFilterChange,
      startDate: startDate,
      endDate: endDate,
      filterData: filterData,
      onClose: hideOverlay,
      organisationBilling: organisationBilling,
      organisationSettings: organisationSettings
    })))
  }, /*#__PURE__*/React.createElement("div", {
    id: "date-filter",
    className: "work-load-analysis-report-page-content-wrapper-menu-filter-date"
  }, /*#__PURE__*/React.createElement("p", {
    className: "work-load-analysis-report-page-content-wrapper-menu-filter-date-text"
  }, arrayToStringOutput([startDate, endDate], organisationSettings.organisationTimezone))))))), /*#__PURE__*/React.createElement("div", null, (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) != "free" ? /*#__PURE__*/React.createElement(Button, {
    className: "monthly-attendence-download-export-button",
    variant: "outline-primary",
    onClick: function onClick() {
      return getExportData();
    }
  }, " ", exportLoading ? "Downloading" : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiDownload, {
    className: "monthly-attendence-download-icon"
  }), " Export")) : /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "bottom",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade your plan to export report")
  }, /*#__PURE__*/React.createElement("div", {
    className: "timesheet-export-button-header disable-timesheet"
  }, /*#__PURE__*/React.createElement(HiDownload, {
    className: "timesheet-download-icon"
  }), " Export"))));
};
export var options = {
  vAxis: {
    title: "Members Count",
    minValue: 0
  },
  colors: ["#F1C40F", "#2ECC71", "#E67E22"],
  legend: {
    position: "bottom"
  },
  tooltip: {
    isHtml: true,
    trigger: "visible"
  },
  seriesType: "bars",
  backgroundColor: {
    fill: "transparent"
  }
};
var ReportChart = function ReportChart(props) {
  var workLoadAnalysisChartDetails = props.workLoadAnalysisChartDetails,
    workLoadChartAnalysisData = props.workLoadChartAnalysisData,
    workLoadChartAnalysisLoading = props.workLoadChartAnalysisLoading,
    organisationSettings = props.organisationSettings,
    workLoadChartAnalysisError = props.workLoadChartAnalysisError;
  var workLoadAnalysisChartData = workLoadAnalysisChartDetails ? workLoadAnalysisChartDetails.reduce(function (acc, curr) {
    var _workLoadChartAnalysi2, _workLoadChartAnalysi3, _workLoadChartAnalysi4, _workLoadChartAnalysi5;
    var date = curr.date,
      overWorkedCount = curr.overWorked,
      healthyCount = curr.healthy,
      lessUtilisedCount = curr.lessUtilised;
    var chartDate = date;

    // console.log({ chartDate });
    return [].concat(_toConsumableArray(acc), [[chartDate, Number(overWorkedCount), "color:#F1C40F", "<div class=\"apps-tootlip\">\n              <span class=\"apps-tootlip-time\">Over Worked</span>\n              <br>\n              <span class=\"apps-tootlip apps-tootlip-title \">Day: ".concat(chartDate, "</span>\n              <br>\n              <span class=\"apps-tootlip apps-tootlip-title \">Members Count: ").concat(overWorkedCount, "</span>\n              <br>\n              <span class=\"apps-tootlip apps-tootlip-title\">Worked more than ").concat(workLoadChartAnalysisData === null || workLoadChartAnalysisData === void 0 ? void 0 : (_workLoadChartAnalysi2 = workLoadChartAnalysisData.workLoadAnalysisReportChart) === null || _workLoadChartAnalysi2 === void 0 ? void 0 : _workLoadChartAnalysi2.overWorkedHours, "</span>\n          </div>"), Number(healthyCount), "color:#2ECC71", "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-time\">Healthy</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title \">Day: ".concat(chartDate, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Members Count: ").concat(healthyCount, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Worked between ").concat(workLoadChartAnalysisData === null || workLoadChartAnalysisData === void 0 ? void 0 : (_workLoadChartAnalysi3 = workLoadChartAnalysisData.workLoadAnalysisReportChart) === null || _workLoadChartAnalysi3 === void 0 ? void 0 : _workLoadChartAnalysi3.lessUtilisedWorkedHours, " to ").concat(workLoadChartAnalysisData === null || workLoadChartAnalysisData === void 0 ? void 0 : (_workLoadChartAnalysi4 = workLoadChartAnalysisData.workLoadAnalysisReportChart) === null || _workLoadChartAnalysi4 === void 0 ? void 0 : _workLoadChartAnalysi4.overWorkedHours, "</span>\n          </div>"), Number(lessUtilisedCount), "color:#E67E22", "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-time\">Less Utilised</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title \">Day: ".concat(chartDate, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Members Count: ").concat(lessUtilisedCount, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-title\">Worked less than ").concat(workLoadChartAnalysisData === null || workLoadChartAnalysisData === void 0 ? void 0 : (_workLoadChartAnalysi5 = workLoadChartAnalysisData.workLoadAnalysisReportChart) === null || _workLoadChartAnalysi5 === void 0 ? void 0 : _workLoadChartAnalysi5.lessUtilisedWorkedHours, "</span>\n          </div>")]]);
  }, [["Month", "Over Worked", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Healthy", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }, "Less Utilised", {
    role: "style"
  }, {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]) : [];
  return /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-chart-content"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: 12,
    md: 12,
    xs: 12,
    className: "work-load-analysis-report-chart-content-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-chart-content-title"
  }, "Work Load Analysis"), workLoadChartAnalysisLoading ? /*#__PURE__*/React.createElement(Loader, null) : workLoadChartAnalysisError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement(Chart, {
    chartType: "ComboChart",
    width: "100%",
    height: "400px",
    data: workLoadAnalysisChartData,
    options: options
  })));
};
var ReportTableData = function ReportTableData(props) {
  var workLoadAnalysisLoading = props.workLoadAnalysisLoading,
    userWorkLoadData = props.userWorkLoadData,
    headerData = props.headerData,
    workLoadAnalysisData = props.workLoadAnalysisData,
    workLoadAnalysisFetchMore = props.workLoadAnalysisFetchMore,
    userParameterCheck = props.userParameterCheck,
    setWorkLoadUserDataFetch = props.setWorkLoadUserDataFetch;
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isAllLoaded = _React$useState10[0],
    setIsAllLoaded = _React$useState10[1];
  var _React$useState11 = React.useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    isLoadingMore = _React$useState12[0],
    setIsLoadingMore = _React$useState12[1];
  var headers = [];
  var workLoadReportTableData = [];
  React.useEffect(function () {
    if ((userWorkLoadData === null || userWorkLoadData === void 0 ? void 0 : userWorkLoadData.length) !== 0 && (userWorkLoadData === null || userWorkLoadData === void 0 ? void 0 : userWorkLoadData.length) < LIMIT && !isAllLoaded) {
      setIsAllLoaded(true);
    }
  }, [workLoadAnalysisData === null || workLoadAnalysisData === void 0 ? void 0 : workLoadAnalysisData.workLoadAnalysisReport]);
  if (headerData) {
    headers = [{
      Header: "Employees",
      accessor: "employee"
    }, {
      Header: "Over Worked",
      accessor: "overWorked"
    }, {
      Header: "Healthy",
      accessor: "healthy"
    }, {
      Header: "Less Utilised",
      accessor: "lessUtilised"
    }].concat(_toConsumableArray(headerData));
  }
  if (userWorkLoadData) {
    workLoadReportTableData = userWorkLoadData.map(function (d) {
      var user = d.user,
        workLoadData = d.workLoadData,
        overWorkedTotalCount = d.overWorkedTotalCount,
        healthyTotalCount = d.healthyTotalCount,
        lessUtilisedTotalCount = d.lessUtilisedTotalCount;
      var workLoadTableDayData = {};
      workLoadData.map(function (dTemp) {
        var date = dTemp.date,
          dateAccessor = dTemp.dateAccessor,
          healthy = dTemp.healthy,
          healthyUserTotal = dTemp.healthyUserTotal,
          lessUtilised = dTemp.lessUtilised,
          lessUtilisedTotal = dTemp.lessUtilisedTotal,
          overWorked = dTemp.overWorked,
          overWorkedUserTotal = dTemp.overWorkedUserTotal;
        var userStatus = null;
        var userWorkedTime = null;
        if (overWorkedUserTotal != 0) {
          userStatus = "overWorked";
          userWorkedTime = overWorked;
        } else if (lessUtilisedTotal != 0) {
          userStatus = "lessUtilised";
          userWorkedTime = lessUtilised;
        } else if (healthyUserTotal != 0) {
          userStatus = "healthy";
          userWorkedTime = healthy;
        }
        workLoadTableDayData = _objectSpread(_objectSpread({}, workLoadTableDayData), {}, _defineProperty(_defineProperty({}, dateAccessor, userWorkedTime), "".concat(dateAccessor, "-status"), userStatus));
      });
      return _objectSpread({
        employee: user.displayName,
        overWorked: overWorkedTotalCount,
        healthy: healthyTotalCount,
        lessUtilised: lessUtilisedTotalCount
      }, workLoadTableDayData);
    });
  }
  setWorkLoadUserDataFetch(false);
  return /*#__PURE__*/React.createElement(TableGrid, {
    headers: headers,
    workLoadReportTableData: workLoadReportTableData,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    workLoadAnalysisFetchMore: workLoadAnalysisFetchMore,
    workLoadAnalysisLoading: workLoadAnalysisLoading,
    userParameterCheck: userParameterCheck
  });
};
var TableGrid = function TableGrid(props) {
  var headers = props.headers,
    workLoadReportTableData = props.workLoadReportTableData,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    workLoadAnalysisFetchMore = props.workLoadAnalysisFetchMore,
    workLoadAnalysisLoading = props.workLoadAnalysisLoading,
    userParameterCheck = props.userParameterCheck;
  var data = workLoadReportTableData;
  var columns = headers;
  var _useTable = useTable({
      columns: columns,
      data: data
    }),
    getTableProps = _useTable.getTableProps,
    getTableBodyProps = _useTable.getTableBodyProps,
    headerGroups = _useTable.headerGroups,
    rows = _useTable.rows,
    prepareRow = _useTable.prepareRow;
  var handleLoadMore = function handleLoadMore() {
    if (workLoadAnalysisLoading) return;
    setIsLoadingMore(true);
    workLoadAnalysisFetchMore({
      variables: {
        offset: workLoadReportTableData === null || workLoadReportTableData === void 0 ? void 0 : workLoadReportTableData.length
      },
      updateQuery: function updateQuery(prev, _ref3) {
        var _fetchMoreResult$work, _fetchMoreResult$work2, _fetchMoreResult$work3, _fetchMoreResult$work4, _prev$workLoadAnalysi, _fetchMoreResult$work5;
        var fetchMoreResult = _ref3.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$work = fetchMoreResult.workLoadAnalysisReport) === null || _fetchMoreResult$work === void 0 ? void 0 : (_fetchMoreResult$work2 = _fetchMoreResult$work.userWorkLoadData) === null || _fetchMoreResult$work2 === void 0 ? void 0 : _fetchMoreResult$work2.length) === 0 && (fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$work3 = fetchMoreResult.workLoadAnalysisReport) === null || _fetchMoreResult$work3 === void 0 ? void 0 : (_fetchMoreResult$work4 = _fetchMoreResult$work3.userWorkLoadData) === null || _fetchMoreResult$work4 === void 0 ? void 0 : _fetchMoreResult$work4.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        //setIsLoadMoreButton(false);
        setIsLoadingMore(false);
        return _objectSpread(_objectSpread({}, prev), {}, {
          workLoadAnalysisReport: _objectSpread(_objectSpread({}, prev.workLoadAnalysisReport), {}, {
            userWorkLoadData: [].concat(_toConsumableArray((_prev$workLoadAnalysi = prev.workLoadAnalysisReport) === null || _prev$workLoadAnalysi === void 0 ? void 0 : _prev$workLoadAnalysi.userWorkLoadData), _toConsumableArray((_fetchMoreResult$work5 = fetchMoreResult.workLoadAnalysisReport) === null || _fetchMoreResult$work5 === void 0 ? void 0 : _fetchMoreResult$work5.userWorkLoadData))
          })
        });
      }
    });
    //setLoadMoreButtonLoading(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "work-load-analysis-report-user-list-table-content"
  }, /*#__PURE__*/React.createElement("table", _extends({
    className: "work-load-analysis-report-user-list-table-table"
  }, getTableProps()), /*#__PURE__*/React.createElement("thead", {
    className: "work-load-analysis-report-user-list-table-thead"
  }, headerGroups.map(function (headerGroup, j) {
    return /*#__PURE__*/React.createElement("tr", _extends({
      className: "work-load-analysis-report-user-list-table-thead-tr"
    }, headerGroup.getHeaderGroupProps(), {
      key: j
    }), headerGroup.headers.map(function (column, i) {
      return /*#__PURE__*/React.createElement("th", {
        className: "work-load-analysis-report-user-list-table-thead-tr-th",
        key: i
      }, column.render("Header"));
    }));
  })), /*#__PURE__*/React.createElement("tbody", _extends({
    className: "work-load-analysis-report-user-list-table-tbody"
  }, getTableBodyProps()), /*#__PURE__*/React.createElement(React.Fragment, null, rows.map(function (row, i) {
    prepareRow(row);
    return /*#__PURE__*/React.createElement("tr", _extends({
      className: "work-load-analysis-report-user-list-table-tbody-tr"
    }, row.getRowProps(), {
      key: i
    }), row.cells.map(function (cell, j) {
      if (j === 0) {
        return /*#__PURE__*/React.createElement("th", {
          className: "work-load-analysis-report-user-list-table-tbody-tr-th",
          key: j
        }, cell.render("Cell"));
      }
      var cellColumnStatusVar = "".concat(cell.column.id, "-status");
      var cellIdStatus = cell.row.original[cellColumnStatusVar];
      var cellId = cell.column.id;
      return /*#__PURE__*/React.createElement("td", _extends({
        className: "work-load-analysis-report-user-list-table-tbody-tr-td ".concat(cellId != "healthy" && cellId != "overWorked" && cellId != "lessUtilised" && cellId != "employee" ? cellIdStatus == "overWorked" ? "work-load-analysis-report-user-list-table-tbody-tr-td-over-worked" : cellIdStatus == "healthy" ? "work-load-analysis-report-user-list-table-tbody-tr-td-healthy" : cellIdStatus == "lessUtilised" ? "work-load-analysis-report-user-list-table-tbody-tr-td-less-utilised" : "work-load-analysis-report-user-list-table-tbody-tr-td-less-utilised-na" : "")
      }, cell.getCellProps(), {
        key: j
      }), cell.render("Cell"));
    }));
  })))), !workLoadAnalysisLoading && workLoadReportTableData && workLoadReportTableData.length != 0 ? /*#__PURE__*/React.createElement("div", {
    className: "monthly-aatendance-load-more-button-div monthly-attendance-scroll-sticky"
  }, !isAllLoaded ? isLoadingMore ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: function onClick() {
      return handleLoadMore();
    }
  }, "Load More") : !userParameterCheck && !userParameterCheck.length ? /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button"
  }, "You have seen all the users") : "") : null);
};
export default WorkLoadAnalysisReport;